import { useAppContext } from 'components/Context/AppContext';
import { Button, InputField } from 'components/Global';
import ImageViewer from 'components/Global/ImageViewer';
import InputTelpField from 'components/Global/InputTelpField';
import SelectFieldShuttle from 'components/Global/SelectFieldShuttle';
import React from 'react';

import { ReactComponent as ReuploadIcon } from 'icons/reupload-icon.svg';
import { getKTPValue, getPassportValue } from 'utils/functionality';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const DetailPenyewa = ({
  rentalLocationData,
  rentalLocation,
  rentalLocationHandler,
  orderData,
  setOrderData,
  customer,
  approvalUpdate,
  imagePreviewHandler,
  selectedOrderData,
}) => {
  const { setShowReviewIdentityModal } = useAppContext();
  const isCharterIdentityReviewEnabled = useFliptBoolean('FLAG_FE_REVIEW_IDENTITY_CHARTER', false, 'anonymous');
  const isUploadNewDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, 'anonymous');

  return (
    <div className="edit-car-charter__content-data__penyewa">
      <h2>Detail Penyewa</h2>
      <div className="edit-car-charter__content-data__penyewa-form">
        <SelectFieldShuttle
          label="Lokasi"
          htmlFor="lokasi-rental"
          data={rentalLocationData}
          value={rentalLocation?.id}
          onChange={rentalLocationHandler}
          placeholder="Pilih Lokasi"
          searchFeature
        />

        <InputField
          type="text"
          label="Nama Penyewa"
          htmlFor="nama-penyewa"
          placeholder="Tulis Nama Penyewa"
          value={orderData.user_name}
          onChange={(e) => setOrderData({ ...orderData, user_name: e.target.value })}
        />

        <InputTelpField
          label="No Telpon / Whatsapp"
          htmlFor="telp-penyewa"
          value={orderData.wa_number || ''}
          onChange={(e) => setOrderData({ ...orderData, wa_number: e.target.value, phone_number: e.target.value })}
          countryCodeValue={orderData.phone_country_code}
          onSelectCountry={(code) => setOrderData({ ...orderData, phone_country_code: code })}
        />

        <InputField
          type="text"
          label="Email"
          htmlFor="email-penyewa"
          placeholder="Masukan Email"
          value={orderData.email}
          onChange={(e) => setOrderData({ ...orderData, email: e.target.value })}
        />

        <ImageViewer
          label="KTP"
          value={getKTPValue(selectedOrderData, customer, isUploadNewDocumentEnabled)}
          onClick={imagePreviewHandler}
          customButton={
            isCharterIdentityReviewEnabled &&
            (selectedOrderData?.order_status === 'PAID' || selectedOrderData?.order_status === 'REVIEWING_IDENTITY') &&
            !approvalUpdate && (
              <>
                <Button type="button" onClick={() => setShowReviewIdentityModal({ type: 'ktp', show: true })}>
                  Tinjau
                </Button>
                {customer?.PersonalInfos?.need_review_ktp && (
                  <div className="reupload-icon">
                    <ReuploadIcon />
                    <p>Upload ulang KTP</p>
                  </div>
                )}
              </>
            )
          }
        />

        <ImageViewer
          label="Passport"
          value={getPassportValue(selectedOrderData, customer, isUploadNewDocumentEnabled)}
          onClick={imagePreviewHandler}
        />
      </div>
    </div>
  );
};

export default DetailPenyewa;
